import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  paperScrollPaper: {
    padding: 25
  },
  contentText: {
    fontFamily: theme.typography.fontFamily,
    // color: Colors.muted,
    // fontSize: Fonts.fontSize.M,
    '& p': {
      marginBottom: 5
    }
  },
  dialogTop: {
    alignItems: 'flex-start'
  },
  withoutFooter: {
    paddingBottom: 24
  },
  footerContainer: {
    zIndex: 420,
    padding: '15px 25px'
  }
}))
